;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import { useState } from 'react';
import { Button, Form, Modal, ModalBody, ModalFooter, ModalHeader, UncontrolledAlert } from 'reactstrap';
import axiosInstance from '../../utils/axios';
import { Dictionaries } from '../../i18n/i18n-config';
import { getI18nUtils } from '../../i18n/i18n-utils';

type Props = {
  isOpen?: boolean;
  toggle: (e: any) => void;
  url: string;
  data?: { [key: string]: string[] };
  onDeleted?: () => void;
  title: string;
  message: string;
  dictionary: Partial<Dictionaries>;
};
const DeleteModal = ({ isOpen = true, toggle, url, data, onDeleted, title, message, dictionary }: Props): JSX.Element => {
  const { formatMessage } = getI18nUtils(dictionary);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(false);

    setSubmitting(true);
    try {
      await axiosInstance.delete(url, data && { data });
      if (onDeleted) onDeleted();
      toggle(e);
    } catch (error) {
      setError(true);
    }
    setSubmitting(false);
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <Form onSubmit={handleSubmit}>
        <ModalHeader toggle={toggle}>{formatMessage({ id: title })}</ModalHeader>
        <ModalBody>
          {error && <UncontrolledAlert color="warning">{formatMessage({ id: 'internal-server-error' })}</UncontrolledAlert>}
          <div className="my-3">{formatMessage({ id: message })}</div>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" type="submit" disabled={submitting}>
            {formatMessage({ id: 'delete' })}
          </Button>
          <Button color="secondary" outline onClick={toggle} disabled={submitting}>
            {formatMessage({ id: 'cancel' })}
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};
export default DeleteModal;
